import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePostManualTreeSectionAdd } from '../../../../../../api/manual-tree/manual-tree';
import { ErrorInfo } from '../../../../../../api/model';
import { useDefaultOptions } from '../../../../../../hooks/api';
import ErrorModal from '../../../../../modules/ErrorModal';
import SpinnerModal from '../../../../../modules/SpinnerModal';

type TreeProps = {
  chapterId: number | undefined;
  productionId: number | undefined;
};
function SectionTreeMenuAdd({ chapterId, productionId }: TreeProps) {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const options = useDefaultOptions(language);
  const { data, mutateAsync, isSuccess, isLoading, isError, error } = usePostManualTreeSectionAdd<
    AxiosError<ErrorInfo>,
    unknown
  >(options);

  const [displayAddError, setDisplayAddError] = useState(false);

  const handlePreview = async () => {
    await mutateAsync({ chapterId: Number(chapterId) });
  };

  useEffect(() => {
    if (isSuccess) {
      if (productionId) {
        const basePath = process.env.REACT_APP_ROUTER_BASEPATH || '';
        window.location.href = `${basePath}/${language}/productions/sections/${productionId}/ps?section_id=${Number(
          data.data.section_id
        )}`;
      }
    }
  }, [isSuccess, productionId, language, data?.data.section_id]);

  useEffect(() => {
    setDisplayAddError(isError);
  }, [isError]);

  return (
    <>
      <li
        onClick={async () => {
          await handlePreview();
        }}
      >
        <i className="fa-solid fa-circle-plus" />
        {t('L2追加')}
      </li>
      {/* スピナーモーダル */}
      {isLoading && <SpinnerModal />}
      {/* 原稿プレビュー */}
      {displayAddError && <ErrorModal error={error} onClickOk={() => setDisplayAddError(false)} />}
    </>
  );
}
export { SectionTreeMenuAdd };
